import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { isNullOrEmpty, translate, getUserNameToName, formatData } from '../../../../utils/util';
import { VISIONS, ENUMS } from '../../../../utils/constants';
import { Row, Modal } from 'react-materialize';
import ButtonUI from '../../../../components/UI/ButtonUI';
import RoutePickingService from '../../../../services/RoutePickingService';
import { getVision } from '../../../../services/auth';

const PickingRouteListItem = (props) => {
    const [openModal, setOpenModal] = useState(false);

    const onConfirm = (route) => {
        props.delete(route, () => {
            setOpenModal(false);
            if (props.refreshComponent) {
                props.refreshComponent();
            }
        });
    };

    const getColorsAlerts = (typeId) => {
        const alerts = Object.values(ENUMS.eTypeAlert);
        const item = alerts.find(f => f.typeAlertId === typeId);
        return item.color;
    }

    return (
        <>
            <span
                className="title sixth-text-color right"
                style={{ position: 'absolute', right: '15px', zIndex: '999' }}
            >
                <Modal
                    open={openModal}
                    options={{ dismissible: false }}
                    id={`modal-id-${props.data.id}`}
                    fixedFooter
                    style={{ marginTop: "15px", maxHeight: "60%" }}
                    actions={
                        <Row className="center" style={{ height: "60%" }}>
                            <ButtonUI secundary='true' onClick={() => setOpenModal(false)} text={translate('cancel', 'general')} />
                            <ButtonUI onClick={() => onConfirm(props.data)} text={translate('delete', 'general')} />
                        </Row>
                    }
                >
                    <div>
                        <Row className="center">
                            <div className="sixth-text-color center">
                                <span className="col s12">
                                    <i className="material-icons large">info_outline</i>
                                </span>
                                <span className="title col s12">{translate('messages.confirmation-delete', 'justification')}</span>
                                <span className="col s12" >{translate('route', 'route-picking')} :{props.data.code}</span>
                                <span className="col s12">{translate('qnt-minimum', 'route-picking')}:{props.data.minQuantity}'</span>
                                {
                                    getVision() === '1-1' && (
                                        <span className="col s12">{translate("trigger-time", "route-picking")}:{props.data.firingTime}</span>
                                    )
                                }
                            </div>
                        </Row>
                    </div>
                </Modal>
                {
                    !props.data.code.includes(translate("partial-material", "picking-route")) &&
                    (<i className="material-icons small sixth-text-color"
                        onClick={() => setOpenModal(true)}
                        style={{ cursor: 'pointer' }}>delete</i>)
                }
            </span>
            <Link
                style={{ display: 'block', paddingTop: "0px" }}
                to={props.route}
                onClick={(event) => {
                    if (props.onSelectChange) {
                        props.onSelectChange(event);
                    }
                }}
            >
                <div className="row">
                    <div className="input-field no-padding col s5">
                        <span className="title sixth-text-color">
                            <i className="mdi mdi-text-box-check-outline" /> {props.data.code}
                        </span>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            <i className="mdi mdi-layers-triple-outline" /> {props.data.minQuantity}
                        </span>
                        {
                            (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && (
                                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                    <i className="mdi mdi-av-timer" /> {props.data.firingTime}
                                </span>
                            )
                        }

                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            <i /> <i className="mdi mdi-history" /> {formatData(props.data.updatedOn) || formatData(props.data.createdOn)}
                        </span>
                        <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                            <i /> <i className="mdi mdi-account" /> {!isNullOrEmpty(props.data.updatedBy) ?
                                `${getUserNameToName(props?.usersFromElog, props.data.updatedBy)}`
                                : getUserNameToName(props?.usersFromElog, props.data.createdBy)} <b>{props.data.updateBy}</b></span>
                    </div>
                    <div className="input-field no-padding col s6">
                        {
                            (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && props.data.alerts?.map((item, index) => (
                                <div key={`${index}-Alerts`}>
                                    {
                                        !isNullOrEmpty(item.time) && item.time > 0 &&
                                        <span className="second-text-color" >
                                            <i className="mdi mdi-camera-timer" style={{ color: getColorsAlerts(item.typeAlertId) }} /> {item.time}
                                        </span>
                                    }
                                    {
                                        !isNullOrEmpty(item.quantity) && item.quantity > 0 &&
                                        <span className="second-text-color" >
                                            <i className="mdi mdi-layers-triple-outline" style={{ color: getColorsAlerts(item.typeAlertId) }} /> {item.quantity}
                                        </span>
                                    }
                                </div>
                            ))
                        }
                    </div>
                </div>
            </Link>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        delete: (route, callback) => {
            dispatch(RoutePickingService.deleteRoute(route.id, callback));
        }

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingRouteListItem)));
